import { render, staticRenderFns } from "./PromoGamesCard.vue?vue&type=template&id=0b455e9c&"
import script from "./PromoGamesCard.vue?vue&type=script&lang=js&"
export * from "./PromoGamesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports